export default __webpack_public_path__ + "static/media/check-in-cn.517bd163.gif";